import Head from "next/head";
import { useEffect, useState } from "react";
import Layout from "../components/Layout";
import styles from "../styles/legal.module.css";
import homeStyles from "../styles/Home.module.css";
import RichTextRenderer from '../components/cms/LegalRichTextRenderer';
import Footer from "../components/Footer.js";
import React from "react";

export default function Terms() {
  const [privacyPolicy, setPrivacyPolicy] = useState({
    "nodeType": "document",
    "data": {},
    "content": [
      {
        "nodeType": "paragraph",
        "content": [
          {
            "nodeType": "text",
            "value": "Loading... ",
            "marks": [],
            "data": {}
          },
        ],
        "data": {}
      },
    ],
  });

  useEffect(() => {
    const getPrivacyPolicy = async () => {
      const response = await fetch("/api/get-privacy-policy", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        }
      });
      const results = await response.json();

      // setTerms(results.content[0].fields.legalContent);
      setPrivacyPolicy(results.content.fields.legalContent);
    }

    getPrivacyPolicy();

  }, []);

  return (
    <Layout backgroundColor="#131f2d">
      <Head>
        <title>Founders Key Privacy Policy</title>
        <meta property="og:title" content="Founders Key Privacy Policy" />
        <meta property="og:url" content="https://www.founderskey.io" />
        <meta
          property="og:image"
          content="https://impacttheory.com/wp-content/uploads/2018/11/impact-theory-logo.png"
        />
      </Head>
      <main
        className={homeStyles.main}
      >

        <div
          className={styles.legal}
          >

          {RichTextRenderer(privacyPolicy)}

        </div>

      </main>
    </Layout>
  );
}
